import { render, staticRenderFns } from "./vendor-transaction-info.vue?vue&type=template&id=6ff6abc5&"
import script from "./vendor-transaction-info.component.ts?vue&type=script&lang=ts&"
export * from "./vendor-transaction-info.component.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\opusb-web-myactio\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6ff6abc5')) {
      api.createRecord('6ff6abc5', component.options)
    } else {
      api.reload('6ff6abc5', component.options)
    }
    module.hot.accept("./vendor-transaction-info.vue?vue&type=template&id=6ff6abc5&", function () {
      api.rerender('6ff6abc5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/app/core/dashboard/components/Custom/vendor-transaction-info.vue"
export default component.exports